<template lang="pug">
.container
  el-col.card-row
    card(
      title="",
      :type="'qtdeCadastro'",
      :value="totalCadastros"
    )
    card(
      :title="municipioMaisCadastros.nome",
      :type="'nomeMunicipioMaisCadastros'",
      :value="municipioMaisCadastros.total"
    )
    card(
      :title="osMaisCadastros.nome",
      :type="'numeroOSMaisCadastros'",
      :value="osMaisCadastros.total"
    )
    card(
      :title="cadastranteMaisCadastros.nome",
      :type="'nomeCadastranteMaisCadastros'",
      :value="cadastranteMaisCadastros.total"
    )
  el-card.box-card.mb
    h4(v-if="tipoGraficoOuTabela==='GRAFICO'").card-title Gráfico
    h4(v-else).card-title Tabela
    el-card.box-card
      vue-horizontal.menu-principal
        div(v-for='tab in itemsMenuPrincipal' :key='tab.nome')
          .tab(:class='{selected: selected === tab.codigo}' @click='changeTab(tab)')
            | {{ tab.nome }}
    el-card.box-card
      Filtro(:isFiltroProcesso="false", @search="pesquisarGraficoTabela", :isGrafico="tipoGraficoOuTabela==='GRAFICO'")
    div(v-if="tipoGraficoOuTabela === 'GRAFICO' && selected !== 'PERIODO'" key="graph").reset
      el-card.box-card
        grafico-relatorios(:dadosLabels="cadastros", :titulo="titulo", v-if="selected !== 'PERIODO'" key="not-per")
    div.periodo-wrapper(v-if="selected === 'PERIODO'" :class="{mh: tipoGraficoOuTabela === 'GRAFICO' }" key="per")
      tabs-periodo(@search="pesquisarPeriodo" :selectedTab="periodoTab")
      div.graph-wrapper(v-if="tipoGraficoOuTabela === 'GRAFICO'" key="graph-wrapper")
        grafico-relatorios-periodo(:dadosLabels="cadastros", :titulo="titulo" v-if="selected === 'PERIODO'" key="per-graph")
      div.tabela-wrapper(v-if="tipoGraficoOuTabela === 'TABELA'" key="per-table")
        tabela-periodo(
          :cadastros="cadastros",
          :tipo="selected",
          :tipoPeriodo="filtroPesquisaGraficoTabela.tipoPeriodo",
          :total="totalNoPeriodo"
        )
    div(v-show="tipoGraficoOuTabela === 'TABELA' && selected !== 'PERIODO'")
      tabela-principal(
        :cadastros="cadastros",
        :tipo="selected",
        :tipoPeriodo="filtroPesquisaGraficoTabela.tipoPeriodo",
        :total="totalNoPeriodo"
      )
    div.buttons-radio
      el-radio-group(v-model="tipoGraficoOuTabela")
        el-radio-button(label="GRAFICO") Gráfico
        el-radio-button(label="TABELA") Tabela
    el-row.button-row()
      el-button(
        v-if="tipoGraficoOuTabela === 'TABELA'"
        type="primary",
        @click="exportarCSV('CADASTROS')"
      ).primary
        i.fal.fa-file-csv
        span &nbsp Exportar CSV
      el-button(
        v-if="tipoGraficoOuTabela === 'GRAFICO'"
        type="primary",
        @click="exportarImagemGrafico('CADASTROS')"
      ).primary
        i.fal.fa-file-download
        span &nbsp Exportar Imagem
    app-paginacao(
      v-if="tipoGraficoOuTabela === 'TABELA'"
      :total="totalCadastrosGeral",
      :pagina="filtroPesquisaGraficoTabela.pagina + 1",
      :tamanhoPagina="15",
      @changePage="changePage"
    )
  el-card.box-card
    h4.card-title Processos
    el-card.box-card
      Filtro(:isFiltroProcesso="true", @search="pesquisarProcessos", :isGrafico="false")
    el-card.box-card
      el-row.divider.table-pointer.mb
        h4.card-title Listagem de processos
        listagem-processo(
          :dados="processos"
        )
      el-row.button-row
        button-acoes-listagem(:acoes="acoesButton", label="Exportar Listagem")
      el-row
        app-paginacao.margin-top(
          :total="totalProcessos",
          :pagina="filtroPesquisaProcesso.pagina + 1",
          :tamanhoPagina="15",
          @changePage="changePageProcesso"
        )
</template>

<script>
import VueHorizontal from 'vue-horizontal'
import Filtro from './components/Filtro'
import MainHeader from '@/components/MainHeader'
import Card from './components/Card'
import GraficoRelatorios from './components/graficos/GraficoRelatorios'
import GraficoRelatoriosPeriodo from './components/graficos/GraficoRelatoriosPeriodo'
import TabsPeriodo from './components/TabsPeriodo'
import { mapActions, mapGetters } from 'vuex'
import TabelaPrincipal from './components/TabelaPrincipal'
import TabelaPeriodo from './components/TabelaPeriodo'
import AppPaginacao from '@/components/AppPaginacao'
import moment from 'moment'
import ListagemProcesso from './components/ListagemProcesso'
import domtoimage from 'dom-to-image'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import format from '@/utils/utils'
import ButtonAcoesListagem from '@/components/ButtonAcoesListagem'

const HOJE = new Date().getTime()
const UM_ANO = new Date().getTime() - 3600 * 1000 * 24 * 365

export default {
  components: {
    MainHeader,
    Card,
    VueHorizontal,
    Filtro,
    GraficoRelatorios,
    GraficoRelatoriosPeriodo,
    TabsPeriodo,
    TabelaPrincipal,
    TabelaPeriodo,
    AppPaginacao,
    ListagemProcesso,
    ButtonAcoesListagem
  },
  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      loading: false,
      totalCadastros: 0,
      municipioMaisCadastros: {
        nome: '',
        total: 0
      },
      osMaisCadastros: {
        nome: '',
        total: 0
      },
      cadastranteMaisCadastros: {
        nome: '',
        total: 0
      },
      itemsMenuPrincipal: [
        {nome: 'Municípios', codigo: 'MUNICIPIOS'},
        {nome: 'Endereços', codigo: 'ENDERECOS'},
        {nome: 'Bairros', codigo: 'BAIRROS'},
        {nome: 'Ordens de serviço', codigo: 'ORDENS_SERVICO'},
        {nome: 'Cadastrante', codigo: 'CADASTRANTE'},
        {nome: 'Período', codigo: 'PERIODO'}
      ],
      selected: 'MUNICIPIOS',
      titulo: 'Municípios',
      cadastros: [],
      totalCadastrosGeral: 0,
      totalNoPeriodo: 0,
      tipoGraficoOuTabela: 'GRAFICO',
      filtroPesquisaGraficoTabela: {
        listIdMunicipio: [],
        listIdOrdemServico: [],
        listIdCadastrante: [],
        listIdPerfilCadastrante: [],
        periodoInicial: moment(UM_ANO).format('DD/MM/YYYY'),
        periodoFinal: moment(HOJE).format('DD/MM/YYYY'),
        tipo: 'MUNICIPIOS',
        tipoPeriodo: 'MENSAL',
        isGrafico: true,
        pagina: 0
      },
      filtroPesquisaProcesso: {
        listIdMunicipio: [],
        listIdOrdemServico: [],
        listIdCadastrante: [],
        listIdPerfilCadastrante: [],
        periodoInicial: moment(UM_ANO).format('DD/MM/YYYY'),
        periodoFinal: moment(HOJE).format('DD/MM/YYYY'),
        cpfCnpjInteressado: '',
        nomeInteressado: '',
        numeroProcesso: '',
        pagina: 0
      },
      processos: [],
      totalProcessos: 0,
      periodoTab: 'MENSAL',
      botaoGerarPdfsDesativado: false,
      usuario: null,
      idsProcessos: [],
      acoesButton: [
        {
          click: () => this.exportarCRF('PROCESSOS'),
          icon: 'file-alt',
          title: 'Exportar CRF',
          active: true
        },
        {
          click: () => this.exportarCSV('PROCESSOS'),
          icon: 'file-csv',
          title: 'Exportar CSV',
          active: true
        },
        {
          click: () => this.gerarZipRelatoriosReurb(),
          icon: 'file-pdf',
          title: 'Gerar zip com os PDFs dos processos',
          active: true
        },
        {
          click: () => this.downloadGeorreferenciamento(),
          icon: 'file-download',
          title: 'Download Georreferenciamento',
          active: true
        }
      ],
      numerosProcessos: []
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  async created () {
    const processos = await this.getProcessosReurb()
    this.usuario = await this.usuarioLogado
    this.totalCadastros = processos.qtdeCadastro
    this.municipioMaisCadastros.nome = processos.nomeMunicipioMaisCadastros || '-'
    this.municipioMaisCadastros.total = processos.qtdeCadastroMunicipioMaisCadastros
    this.osMaisCadastros.nome = processos.numeroOSMaisCadastros || '-'
    this.osMaisCadastros.total = processos.qtdeCadastroOSMaisCadastros
    this.cadastranteMaisCadastros.nome = processos.nomeCadastranteMaisCadastros || '-'
    this.cadastranteMaisCadastros.total = processos.qtdeCadastrosCadastranteMaisCadastros
  },

  methods: {
    ...mapActions({
      getZipRelatoriosReurb: 'relatoriosReurb/getZipRelatoriosReurb',
      getProcessosReurb: 'relatoriosReurb/getProcessosReurb',
      getDadosGraficosMunicipio: 'dashboardRelatorios/getProcessosByMunicipio',
      getReurbDataByFilter: 'relatoriosReurb/getReurbDataByFilter',
      getProcessosReurbByFilter: 'relatoriosReurb/getProcessosReurbByFilter',
      exportaCSVCadastro: 'relatoriosReurb/exportaCSVCadastro',
      exportaCSVProcesso: 'relatoriosReurb/exportaCSVProcesso',
      exportarGeorreferenciamento: 'relatoriosReurb/exportarGeorreferenciamento',
      exportaCRFProcesso: 'relatoriosReurb/exportaCSVCRF',
      resetLoader: 'loader/resetLoader',
      setLoader: 'loader/setLoader'
    }),

    gerarZipRelatoriosReurb () {
      this.confirmBox(
        `Ao confirmar será enviado para seu e-mail um arquivo zip com os PDFs.`,
        this.$messages.TITULO_WARNING, () => {
          this.getZipRelatoriosReurb(this.filtroPesquisaProcesso)
          this.botaoGerarPdfsDesativado = true

          this.$alert(`Os PDFs estão sendo gerados, e dentro de alguns minutos será enviado para seu e-mail
            ${this.usuario && this.usuario.pessoa.email ? `(${this.usuario.pessoa.email})` : ''} uma mensagem com link,
            para download do arquivo com os PDFs de Relatórios REURB.`, 'Sucesso', {
            confirmButtonText: 'Ok',
            type: 'success'
          })
        },
        () => {}
      )
    },

    downloadGeorreferenciamento () {
      this.confirmBox(
        `Ao confirmar, os arquivos Shapefile e as peças técnicas correspondentes aos processos existentes na listagem serão processados. Filtragens muito abrangentes podem gerar arquivos grandes.`,
        'Confirmação', () => {
          const config = this.idsProcessos.length ? {
            mensagem: 'Os arquivos Shapefile e as peças técnicas estão sendo processados e o download começará automaticamente ao término. Processos que não contêm Shapefiles ou peças técnicas serão ignorados.',
            tipo: 'Sucesso',
            acoes: {confirmButtonText: 'Ok', type: 'success'}
          } : {
            mensagem: 'Não foi identificado nenhum processo na listagem. Por favor, revise os filtros aplicados e tente novamente.',
            tipo: 'Alerta',
            acoes: {confirmButtonText: 'Ok', type: 'warning'}
          }

          if (this.idsProcessos.length) {
            this.exportarGeorreferenciamento(this.filtroPesquisaProcesso)
          }

          this.$alert(config.mensagem, config.tipo, config.acoes)
        },
        () => {}
      )
    },

    changeTab (tab) {
      this.cadastros = []
      this.periodoTab = 'MENSAL'
      this.titulo = tab.nome
      this.filtroPesquisaGraficoTabela.tipoPeriodo = this.periodoTab
      this.tipoGraficoOuTabela = 'GRAFICO'
      this.filtroPesquisaGraficoTabela.isGrafico = true
      this.selected = tab.codigo
      this.filtroPesquisaGraficoTabela.pagina = 0
      this.filtroPesquisaGraficoTabela.tipo = tab.codigo
      this.reurbDataByFilter(this.filtroPesquisaGraficoTabela)
    },

    changePage (newPage) {
      this.filtroPesquisaGraficoTabela.pagina = newPage - 1
      this.reurbDataByFilter(this.filtroPesquisaGraficoTabela)
    },

    changePageProcesso (newPage) {
      this.filtroPesquisaProcesso.pagina = newPage - 1
      this.findProcessoReurbByFilter(this.filtroPesquisaProcesso)
    },

    async reurbDataByFilter (filtro) {
      const filtroAtualizado = {
        ...filtro,
        tipo: this.selected,
        isGrafico: this.tipoGraficoOuTabela === 'GRAFICO'
      }
      this.cadastros = []
      const res = await this.getReurbDataByFilter(filtroAtualizado)
      this.cadastros = res.content
      this.totalCadastrosGeral = res.total
      this.totalNoPeriodo = res.somatorioTotalValores
    },

    pesquisarGraficoTabela (data) {
      this.cadastros = []
      data.periodo
        ? this.filtroPesquisaGraficoTabela = {
          ...data,
          tipo: this.selected,
          periodoInicial: moment(data.periodo[0]).format('DD/MM/YYYY'),
          periodoFinal: moment(data.periodo[1]).format('DD/MM/YYYY'),
          isGrafico: this.tipoGraficoOuTabela === 'GRAFICO'
        } : this.filtroPesquisaGraficoTabela = {
          ...data,
          tipo: this.selected,
          isGrafico: this.tipoGraficoOuTabela === 'GRAFICO'
        }
      this.reurbDataByFilter(this.filtroPesquisaGraficoTabela)
    },

    pesquisarProcessos (data) {
      data.periodo
        ? this.filtroPesquisaProcesso = {
          ...data,
          periodoInicial: moment(data.periodo[0]).format('DD/MM/YYYY'),
          periodoFinal: moment(data.periodo[1]).format('DD/MM/YYYY')
        } : this.filtroPesquisaProcesso = {
          ...data
        }
      this.idsProcessos = []
      this.findProcessoReurbByFilter(this.filtroPesquisaProcesso)
    },

    pesquisarPeriodo (data) {
      this.cadastros = []
      this.filtroPesquisaGraficoTabela.tipoPeriodo = data.tipoPeriodo
      this.reurbDataByFilter(this.filtroPesquisaGraficoTabela)
    },

    findProcessoReurbByFilter (filtro) {
      this.numerosProcessos = []
      const filtroPayload = {...filtro}
      this.getProcessosReurbByFilter(filtroPayload).then((res) => {
        this.numerosProcessos = res.ListaAllNumerosProcessos
        res.processos.forEach(p => {
          this.idsProcessos.push(p.id)
        })
        this.processos = res.processos
        this.totalProcessos = res.total
      })
    },

    exportarCSV (tabela) {
      let filtro
      if (tabela === 'CADASTROS') {
        filtro = {...this.filtroPesquisaGraficoTabela, tipo: this.selected}
        this.exportaCSVCadastro(filtro)
      } else {
        filtro = this.filtroPesquisaProcesso
        this.exportaCSVProcesso(filtro)
      }
    },

    exportarCRF (tabela) {
      this.exportaCRFProcesso(this.numerosProcessos)
    },

    formatDate (data, formato) {
      return format.formatDate(data, formato)
    },

    exportarImagemGrafico () {
      if (this.cadastros.length > 10) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Atenção! Os dados a serem exportados são referentes aos exibidos nesta tela de acordo com os filtros realizados. Para visualizar todos os dados filtrados selecione a opção "Tabela".',
          8000
        )
      }

      this.setLoader()
      const that = this
      const nomeSelecao = that.selected !== 'PERIODO' ? that.selected.toLowerCase() : that.selected.toLowerCase() + '_' + that.periodoTab.toLowerCase()
      let exportDate = this.formatDate(new Date(), 'DD-MM-YYYY_HH:mm:ss')
      domtoimage.toBlob(document.getElementById(this.selected !== 'PERIODO' ? 'graficoRelatorios' : 'graficoRelatoriosPeriodo'))
        .then(function (blob) {
          window.saveAs(blob, 'grafico_' + nomeSelecao + '_' + exportDate + '.png')
          that.resetLoader()
        })
    }
  },

  watch: {
    'tipoGraficoOuTabela' (val, oldVal) {
      if (val !== oldVal) {
        this.filtroPesquisaGraficoTabela.pagina = 0
        this.reurbDataByFilter(this.filtroPesquisaGraficoTabela)
      }
    },

    'filtroPesquisaGraficoTabela.tipoPeriodo' (val) {
      this.periodoTab = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';
  .container {
    display: flex;
    flex-direction: column;
    padding: 30px;
    align-items: center;
  }
  .full-width {
    width: 100%;
  }
  .card-row{
    display: flex;
    justify-content: space-between;
  }
  .menu-principal {
    height: 100%;
    display: flex;
    width: 100%;

    :first-child {
      justify-content: space-around;
    }

  }
  .box-card {
    width: 100%;
    border-radius: 15px;
    margin-bottom: 23px;

    div {
      padding: 0
    }
  }
  .tabs {
  border-bottom: 1px solid #e2e8f0;
  }

  .tab {
    padding: 8px 24px 6px 24px;
    font-size: 0.85rem;
    color: #a7a7a7;
    font-weight: 800;
    cursor: pointer;
  }

  .tab.selected {
    border-bottom: 2px solid #B8D700;
    color: #606266;
    font-size: 1rem;
  }
  .filter-title {
    font-size: 1.5rem;
    font-weight: 800;
    margin-bottom: 2rem;
  }
  .buttons-radio {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    top: -40px
  }
  .mb {
    margin-bottom: 23px;
  }
  .card-title {
    margin-top: 0;
    font-weight: 900;
    font-size: 1.1rem;
  }
  .button-row {
    display: flex;
    justify-content: flex-end;
    padding: 0 33px;
  }
  .periodo-wrapper {
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-top: none;
    border-radius: 15px;
    margin-bottom: 20px;
  }
  .graph-wrapper, .tabela-wrapper {
    margin: 0 20px;
  }
  .mh {
    min-height: 450px;
  }

  .margin-top {
    margin-top: 12px;
  }

    @media (max-width: 780px){
    .card-row{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    }

  }

</style>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/Home.vue